





























import Vue, { PropType } from 'vue';
import store from '@/store';

import { WebRequestStatus } from '@/models';
import { Outcome, Objective, Usage } from '@/models/packet';

import DeleteButtonWithMessage from '@/components/DeleteButtonWithMessage.vue';
import LoadingItem from '@/components/LoadingItem.vue';
import MultiPointOutcomeInput from '@/components/MultiPointOutcomeInput.vue';

export default Vue.extend({
  components: {
    DeleteButtonWithMessage,
    LoadingItem,
    MultiPointOutcomeInput
  },

  props: {
    outcome: {
      type: Object as PropType<Outcome>,
      required: true
    },
    objectives: {
      type: Array as PropType<Objective[]>,
      required: true
    }
  },

  computed: {
    usage(): Usage {
      return store.state.usage.usage;
    },

    canDelete(): boolean {
      return this.usage.userCount === 0;
    },

    deleteStatus(): WebRequestStatus {
      return store.state.usage.status;
    },

    message(): string {
      return (
        `This column cannot be deleted, becasse ${this.outcome.value} has been referenced ` +
        'by at least one self-assessment or peer-assessment'
      );
    },

    allowHide(): boolean {
      return this.outcome.outcomeId > 0;
    }
  },

  methods: {
    save(fields: { value: string; color: string }) {
      this.$emit('save', fields);
    },

    close() {
      this.$emit('close');
    },

    hide() {
      this.$emit('hide');
    },

    deleteOutcome() {
      this.$emit('delete', this.outcome);
    }
  }
});
